import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import EventTabNav from "../../EventPage/components/EventTabNav";

const ClassicSectionNav = ({ title, status, sections, onJump }) => {
  const sentinelRef = useRef(null);
  const [stuck, setStuck] = useState(false);
  const [active, setActive] = useState(sections[0]?.id);
  const sectionIds = sections.map((section) => section.id).join(",");

  useEffect(() => {
    if (!sentinelRef.current || typeof IntersectionObserver === "undefined") return undefined;
    const observer = new IntersectionObserver(([entry]) => setStuck(!entry.isIntersecting));
    observer.observe(sentinelRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    setActive((current) => (sections.some((section) => section.id === current) ? current : sections[0]?.id));
  }, [sectionIds]);

  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting);
        if (visible.length === 0) return;
        visible.sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        setActive(visible[0].target.id);
      },
      { rootMargin: "-64px 0px -60% 0px" }
    );
    sections.forEach((section) => {
      const el = document.getElementById(section.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [sectionIds]);

  const jump = (id) => {
    setActive(id);
    onJump(id);
  };

  return (
    <>
      <div ref={sentinelRef} aria-hidden="true" />
      <nav className="classic-section-nav" aria-label="Page sections">
        {stuck ? (
          <div className="classic-section-nav__event">
            <span className="classic-section-nav__name">{title}</span>
            {status}
          </div>
        ) : null}
        <div className="classic-section-nav__tabs event-page">
          <EventTabNav
            tabs={sections.map((section) => ({ key: section.id, label: section.label, locked: section.locked }))}
            active={active}
            onSelect={jump}
          />
        </div>
      </nav>
    </>
  );
};

ClassicSectionNav.propTypes = {
  title: PropTypes.string.isRequired,
  status: PropTypes.node,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      locked: PropTypes.bool,
    })
  ).isRequired,
  onJump: PropTypes.func.isRequired,
};

ClassicSectionNav.defaultProps = { status: null };

export default ClassicSectionNav;
